import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
 
import { AuthenticationService } from '../_services';
 
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}
 
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // console.log(err, 'ErrorInterceptor')
            if (err.status === 400 || err.status === 401) {
                // auto logout if 400 response returned from api
                this.authenticationService.logout();
                // location.reload(true);
            }
            const errors = err.error.mesg;
            let mesg:any;
            if(typeof errors === 'object'){
                mesg = Object.keys(errors).map(key=> errors[key]).join(',');
            }else{
                mesg = errors;
            }
            const error = mesg || err.statusText;
            return throwError(error);
        }))
    }
}